import React, { Component, Fragment } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import { t } from 'ttag';
import { trackStructEvent } from '../utils/snowplow';

import GenericPopup from '../reusable-components/GenericPopup/GenericPopup';

class SubMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      isClosing: false,
      showPopupPrivacy: false,
      showPopupTerms: false,
      showImprintTerms: false
    };
  }

  closeSubMenu = el => {
    this.props.closeSubMenu(el);
    if (this.state.id === el) {
      this.setState({ id: null });
    }
  };

  handleClick() {
    this.setState({ isClosing: true });
    setTimeout(() => {
      this.closeSubMenu(this.props.el.base_item_id);
    }, 200);
  }

  openSubMenu(element) {
    this.setState({
      id: element.base_item_id
    });

    window?.dataLayer?.push?.({
      event: 'navigationClick',
      navigation: {
        type: 'burgerMenu',
        name: element?.title || undefined,
        level: this.props.level + 1
      }
    });
  }

  returnNoOfProducts(num) {
    if (num) {
      return <span className="numOfProds">({num})</span>;
    }
    return null;
  }

  renderPP = () =>
    this.state.showPopupPrivacy && (
      <GenericPopup
        title="Read our terms"
        closeModal={() => this.setState({ showPopupPrivacy: false })}
        type="policy"
        name="privacy"
        target=".site-modal"
      />
    );

  renderPT = () =>
    this.state.showPopupTerms && (
      <GenericPopup
        title="Read our terms"
        closeModal={() => this.setState({ showPopupTerms: false })}
        type="policy"
        name="terms"
        target=".site-modal"
      />
    );

  renderIT = () =>
    this.state.showImprintTerms && (
      <GenericPopup
        title="Read our terms"
        closeModal={() => this.setState({ showImprintTerms: false })}
        type="policy"
        name="imprint"
        target=".site-modal"
      />
    );

  renderWD = () =>
    this.state.showWithdrawalTerms && (
      <GenericPopup
        title="Read our terms"
        closeModal={() => this.setState({ showWithdrawalTerms: false })}
        type="policy"
        name="withdrawal"
        target=".site-modal"
      />
    );

  renderLM = () =>
    this.state.showLegalMentions && (
      <GenericPopup
        title="Read our terms"
        closeModal={() => this.setState({ showLegalMentions: false })}
        type="policy"
        name="legal_information"
        target=".site-modal"
      />
    );

  render() {
    return (
      <CSSTransitionGroup
        transitionAppear
        transitionAppearTimeout={200}
        transitionEnterTimeout={200}
        transitionLeaveTimeout={200}
        transitionName="SlideMenu"
      >
        <ul
          className={this.state.isClosing ? 'SlideMenu-leave-active' : null}
          data-testid={this.props.el.title}
        >
          {this.renderPP()}
          {this.renderPT()}
          {this.renderIT()}
          {this.renderWD()}
          {this.renderLM()}
          <li className="topLevelMenu titleHolder">
            <span
              onClick={() => this.handleClick()}
              className="sg-icon icon-mobile-menu-smallarrow-grey icon-mobile-menu-smallarrow-grey-dims flip"
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
              aria-label={t`Go Back`}
            />
            {this.props.el.title}
            <span
              onClick={() => this.props.closeMenu()}
              className="closeMenuBtn sg-icon icon-close-2 icon-close-2-dims"
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
              aria-label={t`Close Menu`}
            />
          </li>
          {this.props.items.map(el => {
            const href = `${
              el.slug.startsWith('/') || el.slug.startsWith('http')
                ? el.slug
                : `/${el.slug}`
            }`;

            let comp = null;
            // Workaround for top menu items and service menu items.
            // Top Menu items always have sorting set but service menu items always have it empty.
            if (el.online && (el.number_of_products > 0 || el.sorting === '')) {
              if (el.breakpoint) {
                comp = (
                  <li key={el.base_item_id}>
                    <span className="submenuTitle">
                      <a
                        target={el.extra_data === 'fullurl' ? '_blank' : null}
                        {...(!el.popup && !el.is_selected && { href })}
                        role="button"
                        tabIndex="0"
                        style={{ outline: 'none' }}
                        onClick={event => {
                          event.preventDefault();

                          if (el.popup) {
                            if (el.slug === 'policies/privacy/') {
                              return this.setState({ showPopupPrivacy: true });
                            }

                            if (el.slug === 'policies/imprint/') {
                              return this.setState({ showImprintTerms: true });
                            }

                            if (el.slug === 'policies/withdrawal/') {
                              return this.setState({
                                showWithdrawalTerms: true
                              });
                            }

                            if (el.slug === 'policies/legal-information/') {
                              return this.setState({ showLegalMentions: true });
                            }

                            if (el.slug === 'policies/terms/') {
                              return this.setState({ showPopupTerms: true });
                            }
                          }

                          if (href) {
                            trackStructEvent(
                              'navigationItem',
                              'click',
                              el.base_item_id,
                              { level: this.props.level + 1 }
                            );

                            if (window.google_tag_manager) {
                              window?.dataLayer?.push?.({
                                event: 'navigationClick',
                                eventCallback: () => {
                                  window.location.href = href;
                                },
                                eventTimeout: 500,
                                navigation: {
                                  type: 'burgerMenu',
                                  name: el?.title || undefined,
                                  level: this.props.level + 1
                                }
                              });
                            }
                            window.location.href = href;
                          }

                          return null;
                        }}
                      >
                        {el.title}
                        {this.returnNoOfProducts(el.number_of_products)}
                        {el.icon && (
                          <span
                            className={`country-icon round icon-flag ${el.icon}`}
                          />
                        )}
                      </a>
                    </span>
                  </li>
                );
              } else {
                comp =
                  el.items.length >= 1 ? (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <li
                      key={el.base_item_id}
                      onClick={() => {
                        this.openSubMenu(el);
                      }}
                    >
                      <span className="submenuTitle">
                        {el.title}{' '}
                        {this.returnNoOfProducts(el.number_of_products)}
                      </span>
                      <span className="sg-icon icon-mobile-menu-smallarrow-grey icon-mobile-menu-smallarrow-grey-dims" />
                    </li>
                  ) : (
                    <li key={el.base_item_id}>
                      <span className="submenuTitle">
                        <a
                          target={el.extra_data === 'fullurl' ? '_blank' : null}
                          href={!el.popup && href}
                          onClick={event => {
                            event.preventDefault();

                            if (el.popup) {
                              if (el.slug === 'policies/privacy/') {
                                return this.setState({
                                  showPopupPrivacy: true
                                });
                              }

                              if (el.slug === 'policies/imprint/') {
                                return this.setState({
                                  showImprintTerms: true
                                });
                              }

                              if (el.slug === 'policies/withdrawal/') {
                                return this.setState({
                                  showWithdrawalTerms: true
                                });
                              }

                              if (el.slug === 'policies/legal-information/') {
                                return this.setState({
                                  showLegalMentions: true
                                });
                              }

                              if (el.slug === 'policies/terms/') {
                                return this.setState({ showPopupTerms: true });
                              }
                            }

                            if (href) {
                              trackStructEvent(
                                'navigationItem',
                                'click',
                                el.base_item_id,
                                { level: this.props.level + 1 }
                              );

                              if (window.google_tag_manager) {
                                window?.dataLayer?.push?.({
                                  event: 'navigationClick',
                                  eventCallback: () => {
                                    window.location.href = href;
                                  },
                                  eventTimeout: 500,
                                  navigation: {
                                    type: 'burgerMenu',
                                    name: el?.title || undefined,
                                    level: this.props.level + 1
                                  }
                                });
                              }
                              window.location.href = href;
                            }

                            return null;
                          }}
                          rel="noreferrer"
                        >
                          {el.title}{' '}
                          {this.returnNoOfProducts(el.number_of_products)}
                        </a>
                      </span>
                    </li>
                  );
              }
            }

            return <Fragment key={el.base_item_id}>{comp}</Fragment>;
          })}
        </ul>

        {this.state.id !== null ? (
          <SubMenu
            level={this.props.level + 1}
            subMenus={this.props.subMenus}
            closeMenu={this.props.closeMenu}
            showAll={this.props.showAll}
            sliderController={this.sliderController}
            items={this.props.subMenus[this.state.id].items}
            el={this.props.subMenus[this.state.id]}
            closeSubMenu={this.closeSubMenu}
          />
        ) : null}
      </CSSTransitionGroup>
    );
  }
}

export default SubMenu;
